<template>
  <v-layout column v-if="keyConceptsSectionState.showSection">
    <SearchAISubtitle
      :title="$t('ai.keyConcept.title')"
      :hasEdit="!keyConceptsSectionState.showHintBar"
      @onEditClick="handleEditClick"
    ></SearchAISubtitle>
    <AnimatedKeyConcepts></AnimatedKeyConcepts>
    <HintBar class="ml-5 mt-2" v-if="keyConceptsSectionState.showHintBar">
      <div slot="content">
        <i18n path="ai.keyConcept.hintBar.text" class="hint-bar-content hint-text">
          <template v-slot:select>
            <WordTag :text="[$t('ai.keyConcept.hintBar.select')]" :selected="true" :animated="false"></WordTag>
          </template>
          <template v-slot:deselect>
            <WordTag :text="[$t('ai.keyConcept.hintBar.deselect')]" :selected="false" :animated="false"></WordTag>
          </template>
          <template v-slot:group><GroupingIcon /></template>
          <template v-slot:ungroup><GroupingIcon :isCollapsing="false" /></template>
        </i18n>
      </div>
    </HintBar>
  </v-layout>
</template>

<script>
import {
  WordTag,
  GroupingIcon
} from '../utils/buttons'
import { HintBar } from '../utils'
import { AnimatedKeyConcepts, SearchAISubtitle } from './index'

export default {
  name: 'KeyConceptSection',
  components: { AnimatedKeyConcepts, SearchAISubtitle, HintBar, WordTag, GroupingIcon },
  computed: {
    researchQuestionProcessed: {
      get () { return this.$store.getters.getResearchQuestionProcessed }
    },
    keyConceptsSectionState: {
      get () { return this.$store.getters.getKeyConceptsSectionState }
    }
  },
  methods: {
    handleEditClick () {
      this.$store.dispatch('updateAiState', 1)
    }
  }
}
</script>

<style scoped>
.slot-wrapper > div > span {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/KeyConceptSection.vue